import React from 'react';

export default function BajoTuAmparo() {
  return (
    <>
        <p>Bajo tu amparo nos acogemos, santa Madre de Dios; <br/> no deseches las súplicas que te dirigimos en nuestras necesidades, <br/> antes bien, líbranos de todo peligro, <br/> ¡oh siempre Virgen, gloriosa y bendita.</p>
    </>
  );
}
